import { Link } from "react-router-dom";
import { Play, Plus, Star } from "lucide-react";
import { resolveUrl } from "../lib/url";

export default function MovieCard({ item, type = "movie" }) {
  if (!item) return null;
  const path = type === "channel" ? `/live/${item.id}` : `/${type === "series" ? "series" : "movie"}/${item.id}`;
  const title = item.title || item.channelName;
  const poster = resolveUrl(item.posterUrl || item.logoUrl);

  return (
    <Link to={path} className="movie-card group relative block flex-shrink-0 w-[150px] sm:w-[180px] lg:w-[210px] rounded-lg overflow-hidden bg-[#111]" data-testid={`card-${item.id}`}>
      <div className="aspect-[2/3] relative overflow-hidden bg-[#0a0a0a]">
        {poster ? (
          <img
            src={poster}
            alt={title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] flex items-center justify-center text-[#444] text-xs uppercase tracking-wider">
            {title}
          </div>
        )}
        {type === "channel" && (
          <div className="absolute top-2 left-2"><span className="live-badge">LIVE</span></div>
        )}
        <div className="absolute inset-0 card-gradient opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-3">
          <div className="flex items-center gap-2 text-xs text-white/90 mb-1.5">
            {item.rating ? (
              <span className="flex items-center gap-1"><Star size={12} className="fill-yellow-400 text-yellow-400" />{item.rating.toFixed(1)}</span>
            ) : null}
            {item.releaseYear && <span>{item.releaseYear}</span>}
            {item.duration && <span>{item.duration}</span>}
            {item.country && <span>{item.country}</span>}
          </div>
          <div className="text-sm font-semibold text-white line-clamp-2">{title}</div>
          {item.genre && item.genre.length > 0 && (
            <div className="text-[10px] text-[#bbb] uppercase tracking-wider mt-1">{item.genre.slice(0, 2).join(" • ")}</div>
          )}
          <div className="flex gap-2 mt-2">
            <div className="w-7 h-7 rounded-full bg-white text-black flex items-center justify-center">
              <Play size={14} className="fill-black" />
            </div>
            <div className="w-7 h-7 rounded-full bg-black/60 border border-white/30 flex items-center justify-center text-white">
              <Plus size={14} />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
